const hex_mixin = {
  data() {
    return {
      min_max_num: [0, 0], // 最小最大值，用来给颜色分段
      hex_list:[]
    }
  },
  methods: {
    hexToDec(str){
    	var hex = str.replace(/[^0-9a-fA-F]/, "")
    	hex = hex.length == 3 ? hex.replace(/(\w)/g, "$1$1,") : hex.replace(/(\w{2})/g, "$1,")
    	return hex.substr(0, hex.length-1).split(",").map(function(item) {
    		return parseInt(item, 16)
    	})
    },

    decToHex(arr){
    	return arr.map(function(item){
    		return (parseInt(item, 10)).toString(16)
    	}).join("")
    },

    getDivColors(hex1, hex2, n){
    	let startArr = this.hexToDec(hex1)
    	let endArr = this.hexToDec(hex2)
    	let gabVal = []
    	let res = []
    	let temp

    	startArr.forEach(function(item, i){
    		gabVal.push(endArr[i] - item)
    	})

    	for(let i=0; i < n; i++){
    		res.push('#'+this.decToHex(startArr.map(function(item, idx){
    			return item + (gabVal[idx]/(n+1))*(i+1)
    		})))
    	}
      res.unshift(hex1)
      res.push(hex2)
      this.hex_list = res
    },

    showHex(num) {
      if (num <= 0) {
        return this.hex_list[0]
      } else {
        let temp = (this.min_max_num[1] - this.min_max_num[0]) / 5 // 段长（默认为5段）
        let num_cha = num - this.min_max_num[0]
        return this.hex_list[Math.floor(num_cha / temp)>=this.hex_list.length ? this.hex_list.length - 1:Math.floor(num_cha / temp)] // 向下取整
      }
    }
  }
}

export { hex_mixin }
